import Vue from 'vue'
import VueRouter, { RouteConfig, Route } from 'vue-router'
import store from '@/store/index.ts'

Vue.use(VueRouter)

const redirToLearnHome = (to: Route, from: Route, next: (to?: string) => void) => {
  if (store.getters['account/isLoggedIn']) {
    next('/learn-home')
  } else {
    next()
  }
}

const redirToLogin = (to: Route, from: Route, next: (to?: string) => void) => {
  if (store.getters['account/isLoggedIn']) {
    next()
  } else {
    next('login')
  }
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'default',
    beforeEnter: redirToLearnHome,
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/register/:email/:name',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: {
      title: 'Registreren'
    }
  },
  {
    path: '/search/:searchText',
    name: 'search',
    component: () => import('@/views/Search.vue')
  },
  {
    path: '/verify/:token',
    name: 'verify',
    component: () => import('@/views/Verify.vue')
  },
  {
    path: '/password-reset/:uidb64/:token',
    name: 'password-reset',
    component: () => import('@/views/ResetPassword.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: 'Inloggen'
    }
  },
  {
    path: '/learn-home',
    name: 'learnHome',
    component: () => import('@/views/learn-home/LearnHome.vue'),
    meta: {
      title: 'Leeromgeving'
    },
    beforeEnter: redirToLogin
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/Settings.vue')
  },
  {
    path: '/overview/:id',
    name: 'overview',
    component: () => import('@/views/overview/Overview.vue'),
    children: [
      {
        path: 'category/:category',
        name: 'category',
        component: () => import('@/views/overview/ContentView.vue')
      },
      {
        path: '',
        name: 'book-content',
        component: () => import('@/views/overview/ContentView.vue')
      },
      {
        path: 'id/:contentId',
        name: 'cinema',
        component: () => import('@/views/overview/Cinema.vue')
      },
      {
        path: 'category/:category/id/:contentId',
        name: 'cinema',
        component: () => import('@/views/overview/Cinema.vue')
      }
    ]
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const title = 'Airlearn.nl'
router.afterEach((to) => {
  Vue.nextTick(() => {
    if (to.meta.title !== undefined) {
      document.title = title + ' | ' + to.meta.title
    } else {
      document.title = title
    }
  })
})

export default router
